import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import ContactInfoForm from 'components/generals/forms/info';
import ActionButton from 'components/ui/buttons/action-button';
import { Link } from 'react-router-dom';

export default function Home__section__13() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__13">
            <section className="nv__section__container">
                <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                    <h1>¿Aun tienes preguntas?</h1>
                </Animated>
                <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                    <p>
                        Al hacer clic en "Conocer más", serás redirigido a nuestro formulario de
                        registro. Uno de nuestros representantes se pondrá en contacto contigo para
                        proporcionarte toda la información que necesitas y ayudarte a dar el primer
                        paso hacia un futuro financiero sólido con ROOTSTOKEN.
                    </p>
                </Animated>
                <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                    <Animated animation={'animate__fadeInDown animate__delay-4s'}>
                        <Link to="https://wa.me/5215531151431" target="_blank">
                            <ActionButton
                                text={'Conocer más'}
                                type="rounded"
                                color="black"
                                onClick={() => {
                                    // dispatch(setDisplayModal(true));
                                }}
                            />
                        </Link>
                    </Animated>
                    {/* <ContactInfoForm /> */}
                </Animated>
            </section>
        </main>
    );
}
